// extracted by mini-css-extract-plugin
module.exports = {"header":"OnboardingHeader_header__2L2Pu","leftAligned":"OnboardingHeader_leftAligned__Ro3zD"};